import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { sponsoredTextOffers as orgConfig } from 'org/configs/modules.config';
import {
  SPONSORED_TEXT_OFFERS_GET_SUCCESS, SPONSORED_TEXT_OFFERS_GET_FAILURE,
} from '../actions/types';

const defaultConfig = {
  defaults: {
    shouldUseMobileRoundedView: false,
    api: {
      options: {
        success: SPONSORED_TEXT_OFFERS_GET_SUCCESS,
        failure: SPONSORED_TEXT_OFFERS_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
        sectionId: 10426,
      },
      params: {
        sort_by: 'random',
        group_by_merchant: 0,
        limit: 5,
        fields: [
          'assets',
          'clickUrl',
          'code',
          'couponCode',
          'stopDatetime',
          'id',
          'disclaimer',
          'merchant',
        ],
      },
    },
  },
  bc: {
    shouldUseMobileRoundedView: true,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
